module.exports = __webpack_public_path__ + "img/zhongxun-coupon-icon.c13e036f.png";